export const ROLE_CONFIGS = {
  ADMIN: {
    prefix: "/admin",
    home: "/admin/dashboard",
    menuItems: [
      { key: "home", label: "Home", icon: "home", to: "/admin/dashboard" },
      { key: "progress", label: "Progress", icon: "business", to: "/admin/progress" },
      { key: "interventions", label: "Interventions", icon: "pulse", to: "/admin/interventions" },
      { key: "driver-interventions", label: "Driver SLA", icon: "car", to: "/admin/driver-interventions" },
      { key: "sales", label: "Sales", icon: "bar-chart", to: "/admin/sales" },
      { key: "business", label: "Business", icon: "shopping", to: "/admin/business" },
      { key: "approvals", label: "Approvals", icon: "card", to: "/admin/approvals" },
      { key: "ambassadors", label: "Ambassadors", icon: "people", to: "/admin/ambassadors" },
      { key: "rate-settings", label: "Rate Settings", icon: "file-tray", to: "/admin/rate-settings" },
      { key: "notifications", label: "Notifications", icon: "notifications", to: "/admin/notifications" },
      { key: "broadcast", label: "Broadcast", icon: "megaphone", to: "/admin/broadcast" },
      { key: "campaign", label: "Campaign", icon: "sync", to: "/admin/campaign" },
      { key: "faqs", label: "FAQs", icon: "help-circle", to: "/admin/faqs" },
      { key: "tools", label: "Tools", icon: "settings", to: "/settings" },
    ],
  },
  SM: {
    prefix: "/support-manager",
    home: "/support-manager",
    menuItems: [
      { key: "home", label: "Home", icon: "home", to: "/support-manager" },
      {
        key: "progress",
        label: "Progress",
        icon: "pulse",
        to: "/support-manager/progress",
      },
      {
        key: "intervention",
        label: "Intervention",
        icon: "pulse",
        to: "/support-manager/intervention",
      },
      {
        key: "driver-intervention",
        label: "Driver SLA",
        icon: "car",
        to: "/support-manager/driver-intervention",
      },
      {
        key: "sales",
        label: "Sales",
        icon: "bar-chart",
        to: "/support-manager/sales",
      },
      {
        key: "business",
        label: "Business",
        icon: "business",
        to: "/support-manager/business",
      },
      { key: "tools", label: "Tools", icon: "settings", to: "/settings" },
    ],
  },
  SE: {
    prefix: "/support-executive",
    home: "/support-executive",
    menuItems: [
      { key: "home", label: "Home", icon: "home", to: "/support-executive" },
      {
        key: "progress",
        label: "Progress",
        icon: "pulse",
        to: "/support-executive/progress",
      },
      {
        key: "intervention",
        label: "Intervention",
        icon: "alert",
        to: "/support-executive/intervention",
      },
      {
        key: "driver-intervention",
        label: "Driver SLA",
        icon: "car",
        to: "/support-executive/driver-intervention",
      },
      {
        key: "sales",
        label: "Sales",
        icon: "bar-chart",
        to: "/support-executive/sales",
      },
      {
        key: "business",
        label: "Business",
        icon: "shopping",
        to: "/support-executive/business",
      },
      {
        key: "approvals",
        label: "Approvals",
        icon: "card",
        to: "/support-executive/approvals",
      },
      {
        key: "ambassadors",
        label: "Ambassadors",
        icon: "people",
        to: "/support-executive/ambassadors",
      },
      { key: "tools", label: "Tools", icon: "settings", to: "/settings" },
    ],
  },
  SO: {
    prefix: "/support-officer",
    home: "/support-officer",
    menuItems: [
      { key: "home", label: "Home", icon: "home", to: "/support-officer" },
      {
        key: "progress",
        label: "Progress",
        icon: "pulse",
        to: "/support-officer/progress",
      },
      {
        key: "sales",
        label: "Sales",
        icon: "bar-chart",
        to: "/support-officer/sales",
      },
      {
        key: "business",
        label: "Business",
        icon: "business",
        to: "/support-officer/business",
      },
      { key: "tools", label: "Tools", icon: "settings", to: "/settings" },
    ],
  },
};
